// eslint-disable-next-line no-restricted-imports
import { Tooltip as TooltipBase, TooltipProps } from '@mui/material';
import { getColor } from 'helpers';

import { styled } from '../styled';
import { ColorsDark, ColorsLight } from '../theme';

import { TooltipClasses } from './types';

export const TooltipStyled = styled(({ className, ...props }: TooltipProps) => (
  <TooltipBase {...props} classes={{ popper: className, ...props.classes }} />
))(({ theme }) => ({
  [TooltipClasses.tooltip.css]: {
    backgroundColor: getColor(theme, {
      light: ColorsLight.black,
      dark: ColorsDark.white,
    }),
    color: getColor(theme, {
      light: ColorsLight.white,
      dark: ColorsDark.black,
    }),
    ...theme.typography.captionMedium,
    padding: '2px 8px',
    borderRadius: 4,
  },

  [TooltipClasses.arrow.css]: {
    color: getColor(theme, {
      light: ColorsLight.black,
      dark: ColorsDark.white,
    }),
  },
}));
